import moment from 'moment';
import momentTimezone from 'moment-timezone';
import { store } from 'store';
import {
  dateDisplayFormatSelector,
  dateTimeDisplayFormatSelector,
  userTimeZoneSelector,
} from 'store/auth/selectors/authSelectors';
export const UTC_TIMEZONE_SLUG = 'UTC';
export const SERVER_FORMATED_DATE_TIME = 'YYYY-MM-DD HH:mm:ss';
export const SERVER_FORMATED_DATE = SERVER_FORMATED_DATE_TIME.split(' ')[0];
export const HUMAN_READABLE_DATE = 'MMM D, YYYY';
export const HUMAN_READABLE_TIME = 'h:mm A';
export const HUMAN_READABLE_TIME_WITH_SECONDS = 'h:mm:ss A';
export const convertToDateObj = (date: any) => {
  return moment(date);
};
export const getCurrentDateTimeObj = () => {
  return moment(new Date());
};
export const getCurrentDateTime = (dateFormat = '') => {
  if (dateFormat == '') {
    const userDateDisplayFormatSelector = dateDisplayFormatSelector(store.getState());
    if (userDateDisplayFormatSelector) {
      dateFormat = userDateDisplayFormatSelector;
    } else {
      dateFormat = 'MM/DD/YYYY';
    }
  }
  return getCurrentDateTimeObj().format(dateFormat);
};
export const getMaxAllowedBirthDate = () => {
  return moment().subtract(18, 'years');
};
export const getServerFormattedDateTime = (date: any, fromFormat = 'MM/DD/YYYY') => {
  // to pass FORMATED DATE Time in API calls
  const dateFormat = SERVER_FORMATED_DATE_TIME;
  return moment(new Date(date), fromFormat).format(dateFormat);
};
export const getServerFormattedDate = (date: any, fromFormat = 'MM/DD/YYYY') => {
  // to pass FORMATED DATE in API calls
  const dateFormat = SERVER_FORMATED_DATE_TIME.split(' ')[0];
  return moment(date, fromFormat).format(dateFormat);
};
export const getFormattedDate = (date: any, dateFormat = '') => {
  if (dateFormat == '') {
    const userDateDisplayFormatSelector = dateDisplayFormatSelector(store.getState());
    if (userDateDisplayFormatSelector) {
      dateFormat = userDateDisplayFormatSelector;
    } else {
      dateFormat = 'MM/DD/YYYY';
    }
  }
  return moment(date).format(dateFormat);
};
export const getFormattedDateTime = (dateTime: any, timeFormat = '') => {
  // to display TIME in a page
  if (timeFormat == '') {
    if (dateTimeDisplayFormatSelector(store.getState())) {
      timeFormat = dateTimeDisplayFormatSelector(store.getState());
    } else {
      timeFormat = 'MM/DD/YYYY HH:mm';
    }
  }
  return moment(dateTime).format(timeFormat);
};

// timezone of the browser, for timestamps that should follow the user's own clock
export const getLocalTimeZone = () => {
  return momentTimezone.tz.guess() || UTC_TIMEZONE_SLUG;
};
// timezone wise date and time format .......start......
export const getFormattedDateTimezonewise = (date: any, timezone = '', dateFormat = '') => {
  if (timezone == '') {
    timezone = userTimeZoneSelector(store.getState());
  }
  if (dateFormat == '') {
    if (dateDisplayFormatSelector(store.getState())) {
      dateFormat = dateDisplayFormatSelector(store.getState());
    } else {
      dateFormat = 'MM/DD/YYYY';
    }
  }
  if (timezone != UTC_TIMEZONE_SLUG) {
    return momentTimezone.utc(date).tz(timezone).format(dateFormat);
  } else {
    return momentTimezone.utc(date).format(dateFormat);
  }
};
export const getFormattedDateTimeTimezonewise = (dateTime: any, timezone = '', timeFormat = '') => {
  if (!dateTime) {
    return '-';
  }
  if (timezone == '') {
    timezone = userTimeZoneSelector(store.getState());
  }
  if (timeFormat == '') {
    if (dateTimeDisplayFormatSelector(store.getState())) {
      timeFormat = dateTimeDisplayFormatSelector(store.getState());
    } else {
      timeFormat = 'MM/DD/YYYY HH:mm';
    }
  }
  if (timezone != UTC_TIMEZONE_SLUG) {
    return momentTimezone.utc(dateTime).tz(timezone).format(timeFormat);
  } else {
    return momentTimezone.utc(dateTime).tz(UTC_TIMEZONE_SLUG).format(timeFormat);
  }
};
// timezone wise date and time format .......end......

export const getRelativeTime = (date: any) => {
  if (!date) return '-';
  const mDate = moment(date);
  const now = moment();

  if (mDate.isSame(now, 'day')) {
    return `today, ${mDate.format(HUMAN_READABLE_TIME)}`;
  } else if (mDate.isSame(now.clone().subtract(1, 'day'), 'day')) {
    return `yesterday, ${mDate.format(HUMAN_READABLE_TIME)}`;
  } else if (now.diff(mDate, 'days') < 7) {
    return mDate.fromNow();
  } else {
    return mDate.format(HUMAN_READABLE_DATE);
  }
};

// countdown label for coupon cards: "2d 5h" while a day or more is left, "5h 20m" after that
export const getTimeLeftLabel = (endDate?: string) => {
  if (!endDate) return '';
  const diff = new Date(endDate).getTime() - new Date().getTime();
  if (diff <= 0) return 'Expired';

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  if (days > 0) return `${days}d ${hours}h`;

  const minutes = Math.floor((diff / 1000 / 60) % 60);
  return `${hours}h ${minutes}m`;
};

export const getNotificationTimeAgo = (date: any, timezone = '') => {
  if (!date) return '';
  if (timezone == '') {
    timezone = userTimeZoneSelector(store.getState());
  }

  const mDate =
    timezone && timezone !== UTC_TIMEZONE_SLUG
      ? momentTimezone.utc(date).tz(timezone)
      : momentTimezone.utc(date);

  const now =
    timezone && timezone !== UTC_TIMEZONE_SLUG
      ? momentTimezone().tz(timezone)
      : momentTimezone.utc();

  const diffMinutes = now.diff(mDate, 'minutes');
  const diffHours = now.diff(mDate, 'hours');
  const diffDays = now.diff(mDate, 'days');

  if (diffMinutes < 1) return 'Just now';
  if (diffMinutes < 60) return `${diffMinutes} mins ago`;
  if (diffHours < 24) return `${diffHours} ${diffHours === 1 ? 'hour' : 'hours'} ago`;
  return `${diffDays} ${diffDays === 1 ? 'day' : 'days'} ago`;
};
